import { render, staticRenderFns } from "./advertisementDialog.vue?vue&type=template&id=1f8f583f&scoped=true"
import script from "./advertisementDialog.vue?vue&type=script&lang=js"
export * from "./advertisementDialog.vue?vue&type=script&lang=js"
import style0 from "./advertisementDialog.vue?vue&type=style&index=0&id=1f8f583f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f583f",
  null
  
)

export default component.exports